// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;I lie in the midst of lions,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;people whose teeth are spears and arrows,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and their tongue a sharp sword.<br> </p> </div></div>";
// Exports
module.exports = code;